import { HOME } from "@/constants/testIds";

const Footer = () => {
  return (
    <footer data-testid={HOME.footer} className="relative border-t border-white/5 px-6 lg:px-12 py-12">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row justify-between items-center gap-4">
        <div className="flex items-center gap-3">
          <img src="/logo.jpg" alt="Skilmark" className="w-10 h-10 rounded-lg object-cover" />
          <span className="font-display font-extrabold text-lg tracking-tight">
            SKIL<span className="text-[#7C93B8]">MARK</span>
          </span>
        </div>
        <p className="text-xs text-white/30 uppercase tracking-[0.2em]">
          Autonomous Marketing. Infinite Scale.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
